<template>
  <login-layout>
    <template slot="content">
      <login-form v-if="showLogin"></login-form>
      <template v-else>
        <div class="text-center">
          <v-progress-circular
            v-if="$router.currentRoute.path === '/social-login'"
            :size="70"
            :width="7"
            color="#F5C955"
            indeterminate
          ></v-progress-circular>
        </div>
      </template>
    </template>
  </login-layout>
</template>

<script>
import LoginLayout from '../components/LoginLayout.vue';
import LoginForm from '../components/LoginForm.vue';

export default {
  components: {
    LoginForm,
    LoginLayout,
  },
  mounted() {
    if (this.$route.query.token && this.$router.currentRoute.path === '/social-login') {
      this.showLogin = false;
      const token = 'Bearer ' + this.$route.query.token;
      this.$store
        .dispatch('loginFromToken', token)
        .then(() => this.$router.push('/dashboard'))
        .catch(() => {
          this.showLogin = true;
        });
    } else {
      this.showLogin = true;
    }
  },
  data() {
    return {
      showLogin: true,
    };
  },
  watch: {
    $route(to, from) {
      this.showLogin = from.path === '/social-login' && to.path === '/login';
    },
  },
};
</script>
